export enum ConversationSessionType {
  ANALYSE_RECORD = 'ANALYSE_RECORD',
  ANALYSE_CONVERSATION = 'ANALYSE_CONVERSATION',
  CHAT = 'CHAT',
}
